import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { ClassNames } from '@emotion/core';
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import Section from '../Section';
import { jsx as ___EmotionJSX } from "@emotion/core";
var gridSize = gridSizeFn();

var MenuSection = /*#__PURE__*/function (_Component) {
  _inherits(MenuSection, _Component);

  var _super = _createSuper(MenuSection);

  function MenuSection() {
    _classCallCheck(this, MenuSection);

    return _super.apply(this, arguments);
  }

  _createClass(MenuSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alwaysShowScrollHint = _this$props.alwaysShowScrollHint,
          id = _this$props.id,
          children = _this$props.children,
          parentId = _this$props.parentId;
      return ___EmotionJSX(Section, {
        id: id,
        parentId: parentId,
        alwaysShowScrollHint: alwaysShowScrollHint,
        shouldGrow: true
      }, function (_ref) {
        var css = _ref.css;

        var menuCss = _objectSpread(_objectSpread({}, css), {}, {
          paddingBottom: gridSize * 1.5
        });

        return ___EmotionJSX(ClassNames, null, function (_ref2) {
          var getClassName = _ref2.css;
          return children({
            css: menuCss,
            className: getClassName(menuCss)
          });
        });
      });
    }
  }]);

  return MenuSection;
}(Component);

_defineProperty(MenuSection, "defaultProps", {
  alwaysShowScrollHint: false
});

export { MenuSection as default };